import { useEffect, useState } from 'react';
import { ModalProps } from '../../../../../../../components/modal/modal';
import { WorkingHoursType } from '../../../../../../../features/working-hours/types';
import { validateLang } from '../../../../../../../helpers/lang';
import { validate } from '../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';
import { getMenuId } from '../../menu-informer-helpers';

export const useMenuInformerCreateMenuModal = (props?: ModalProps) => {
  const { t } = useLang();
  const [step, setStep] = useState(0);
  const { fetchMenu, menu, isLoading, postMenu, putMenu, handleUpdateMenu } = useDishMenuStore();
  const [showWorkingHours, setShowWorkingHours] = useState(false);

  const { getQueryParams, addQueryParams } = useQueryParams();

  const params = getQueryParams();
  const id = params.id;

  useEffect(() => {
    if (id) fetchMenu(id);
  }, [id, fetchMenu]);

  const handleUpdateSpecs = (specs: WorkingHoursType['specs']) => {
    handleUpdateMenu({ working_hours: { ...menu?.working_hours, specs } });
  };

  const handleUpdateWeek = (week: WorkingHoursType['week']) => {
    handleUpdateMenu({ working_hours: { ...menu?.working_hours, week } });
  };

  const branchId = params.branchId;

  const handleNextStep = async () => {
    if (step === 0) {
      const isValid = validate({
        name: { rule: () => validateLang(menu?.name) },
        codes: { rule: () => !!menu?.qr_ids?.length },
      });
      if (!isValid) return;

      if (!menu?.place_id) handleUpdateMenu({ place_id: Number(branchId) });

      if (getMenuId()) {
        await putMenu();
      } else {
        const menu = await postMenu();
        addQueryParams({ menuId: menu.id });
      }
    }

    if (step === 2) {
      await putMenu();
      props?.onClose();
    }

    setStep(step + 1);
  };

  const handlePrevStep = () => {
    const prevStep = step - 1;
    if (prevStep < 0) props?.onClose();
    setStep(step - 1);
  };

  const handleBackClick = () => {
    setShowWorkingHours(false);
  };

  return {
    t,
    step,
    handleNextStep,
    handlePrevStep,
    isLoading,
    id,
    showWorkingHours,
    setShowWorkingHours,
    specs: menu?.working_hours?.specs || [],
    week: menu?.working_hours?.week || [],
    handleUpdateSpecs,
    handleUpdateWeek,
    handleBackClick,
  };
};
